var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1662_48624",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1662_48624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83398 17.5C5.37565 17.5 4.98329 17.3368 4.6569 17.0104C4.33051 16.684 4.16732 16.2917 4.16732 15.8333V5C3.93121 5 3.73329 4.92014 3.57357 4.76042C3.41385 4.60069 3.33398 4.40278 3.33398 4.16667C3.33398 3.93056 3.41385 3.73264 3.57357 3.57292C3.73329 3.41319 3.93121 3.33333 4.16732 3.33333H7.50065C7.50065 3.09722 7.58051 2.89931 7.74023 2.73958C7.89996 2.57986 8.09787 2.5 8.33398 2.5H11.6673C11.9034 2.5 12.1013 2.57986 12.2611 2.73958C12.4208 2.89931 12.5007 3.09722 12.5007 3.33333H15.834C16.0701 3.33333 16.268 3.41319 16.4277 3.57292C16.5875 3.73264 16.6673 3.93056 16.6673 4.16667C16.6673 4.40278 16.5875 4.60069 16.4277 4.76042C16.268 4.92014 16.0701 5 15.834 5V15.8333C15.834 16.2917 15.6708 16.684 15.3444 17.0104C15.018 17.3368 14.6257 17.5 14.1673 17.5H5.83398ZM14.1673 5H5.83398V15.8333H14.1673V5ZM8.33398 14.1667C8.5701 14.1667 8.76801 14.0868 8.92773 13.9271C9.08746 13.7674 9.16732 13.5694 9.16732 13.3333V7.5C9.16732 7.26389 9.08746 7.06597 8.92773 6.90625C8.76801 6.74653 8.5701 6.66667 8.33398 6.66667C8.09787 6.66667 7.89996 6.74653 7.74023 6.90625C7.58051 7.06597 7.50065 7.26389 7.50065 7.5V13.3333C7.50065 13.5694 7.58051 13.7674 7.74023 13.9271C7.89996 14.0868 8.09787 14.1667 8.33398 14.1667ZM11.6673 14.1667C11.9034 14.1667 12.1013 14.0868 12.2611 13.9271C12.4208 13.7674 12.5007 13.5694 12.5007 13.3333V7.5C12.5007 7.26389 12.4208 7.06597 12.2611 6.90625C12.1013 6.74653 11.9034 6.66667 11.6673 6.66667C11.4312 6.66667 11.2333 6.74653 11.0736 6.90625C10.9138 7.06597 10.834 7.26389 10.834 7.5V13.3333C10.834 13.5694 10.9138 13.7674 11.0736 13.9271C11.2333 14.0868 11.4312 14.1667 11.6673 14.1667Z",
    fill: "#40414C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteDefault);
export default __webpack_public_path__ + "static/media/delete-default.9be9f8aa8ca6d9ea41ada5b708effeec.svg";
export { ForwardRef as ReactComponent };